/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2021-05-26 16:25:43
 */
// 品牌内容/行业内容占比
import IndustryContent from './IndustryContent/IndustryContent'

// 心智占有率图，要支持自定义数据输入
import ShareOfMind from './ShareOfMind/ShareOfMind'
// 分平台口碑舆情图
import ChartPie from './ChartPie/ChartPie'

// KOL参与图，要支持自定义数据输入
import KOL from './KOL/KOL'

// 受众好感图，要支持自定义数据输入
import Favor from './Favor/Favor'
import KeyValuePie from './KeyValuePie/KeyValuePie'


// 内容交集图
import venn from './venn/venn'
// 内容分平台占比

import Multiaxis from './Multiaxis'
import MultiaxisD3 from './MultiaxisD3'
import WordCloud from './WordCloud'
import KeyMediaGraph from './KeyMediaGraph'
import HotTopic from './HotTopic'
import FiveFavor from './FiveFavor/FiveFavor'

export default {
  IndustryContent,
  // WordOfMouthContrast,
  ShareOfMind,
  ChartPie,
  KOL,
  Favor,
  // ChartPieRatio,
  KeyValuePie,
  venn,
  Multiaxis,
  MultiaxisD3,
  WordCloud,
  KeyMediaGraph,
  HotTopic,
  FiveFavor
}


// WEBPACK FOOTER //
// src/routes/customChart/router.js